import { Route } from "react-router-dom";
import Accounts from "./Accounts";
import AddAccount from "./AddAccount";

export default (
  <Route path="Accounts" exact element={<Accounts />}>
    <Route path="SiteDetail/:id/AddAccount" element={<AddAccount />} />
  </Route>
);
